module.exports = __webpack_public_path__ + "images/emoji/waning_crescent_moon.f3a3cba41f1f19409f96.png";